import React,{useEffect} from 'react';
import PropTypes from 'prop-types';
import { useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//components
import ModalCustom from 'components/backoffice/modals/ModalCustom';

const WatchModal = ({ title, item, show, setShow, size, beforeTitle }) => {
  const { t } = useTranslation(['backoffice']);
  const { setTitle} = useOutletContext()

  useEffect(() => {
    if(show){
      setTitle(title)
    }
  },[show,title])

  const handleClose = () => {
    setShow(false)
    setTitle(beforeTitle)
  }

  return (
    <>
      <ModalCustom show={show} onHide={handleClose} title={title} size={size || "md"}>
        <div className="watchlist-image-box">
          {typeof item === 'string' && item !== '' ? (
            <img className="w-100 h-auto" src={item} alt="Item" />
          ) : item && item?.image ? (
            <img className="w-100 h-auto" src={item.image} alt="Item" />
          ) : (
            <p>{t('noimage')}</p>
          )}
        </div>
      </ModalCustom>
    </>
  );
};

WatchModal.propTypes = {
  title: PropTypes.string,
  item: PropTypes.any,
  show: PropTypes.bool,
  setShow: PropTypes.func,
  size: PropTypes.string,
  beforeTitle: PropTypes.string,
};

export default WatchModal;
